import sliceCreator from '../../index.js';
import {GET_RAW_MATERIALS} from '../../../constants/index.js';
const _getRawMaterialsAction = sliceCreator('GET_RAW_MATERIALS', GET_RAW_MATERIALS, 'get');

const { asyncAction: getRawMaterialsAction, reducer, clearData: clearGetRawMaterialsAction } = _getRawMaterialsAction;

export default reducer;

export {
    getRawMaterialsAction,
    clearGetRawMaterialsAction
}